<template>
  <div>
    <Card
      :hasHeaderDivider="true"
    >
      <template v-slot:header>
        <div class="cardTitle">
          <HeadingMedium>
            Cloud Backups
          </HeadingMedium>
          <ParagraphBody
            v-if="hasErrorLoadingCloudBackups"
            class="errorText"
            :data-test-id="$testId('errorText')"
          >
            Error while loading settings
          </ParagraphBody>
          <StatusBadge
            v-if="isCloudBackupsEnabled"
            status="success"
            text="Enabled"
          />
        </div>
        <ParagraphBody>
          Enabling Cloud Backups means your vault will be backed up on JumpCloud's servers
          instead of on your devices.
          Security is enforced by requiring a public and private key combo for access.
          <Link
            isExternal
            text="Learn More: Password Manager Cloud Backups"
            to="/passwordmanager"
          />
        </ParagraphBody>
      </template>
      <template v-slot:body>
        <LoadingIcon
          v-if="isLoadingCloudBackups"
          :isCloud="false"
          :scale="0.75"
        />
        <PasswordManagerPrivateKeys
          v-if="isCloudBackupsEnabled"
          class="passwordManagerPrivateKeys"
        />
        <ButtonSecondary
          v-if="isCloudBackupsEnabled"
          :data-test-id="$testId('disableCloudBackupsButton')"
          text="Disable Cloud Backups"
          type="error"
        />
        <ButtonSecondary
          v-else-if="hasLoadedCloudBackups"
          :data-test-id="$testId('enabledCloudBackupsButton')"
          text="Enable Cloud Backups"
        />
      </template>
    </Card>
  </div>
</template>

<script>
import {
  ButtonSecondary,
  Card,
  HeadingMedium,
  Link,
  LoadingIcon,
  ParagraphBody,
  StatusBadge,
} from '@jumpcloud/ui-components';
import { mapActions, mapGetters } from 'vuex';
import PasswordManagerPrivateKeys from 'client/PasswordManager/Settings/BackupKeys/PasswordManagerPrivateKeys';

const PasswordManagerCloudBackupModule = 'PasswordManagerCloudBackupModule';

export default {
  name: 'PasswordManagerCloudBackupsSection',

  components: {
    ButtonSecondary,
    Card,
    HeadingMedium,
    Link,
    LoadingIcon,
    ParagraphBody,
    PasswordManagerPrivateKeys,
    StatusBadge,
  },

  computed: {
    ...mapGetters(PasswordManagerCloudBackupModule, {
      hasErrorLoadingCloudBackups: 'hasErrorLoadingActiveKeys',
      hasLoadedCloudBackups: 'hasLoadedActiveKeys',
      isCloudBackupsEnabled: 'isCloudBackupsEnabled',
      isLoadingCloudBackups: 'isLoadingActiveKeys',
    }),
  },

  created() {
    this.loadCloudBackups();
  },

  destroyed() {
    this.clearCloudBackups();
  },

  methods: {
    ...mapActions(PasswordManagerCloudBackupModule, {
      loadCloudBackups: 'fetchActiveKeys',
      clearCloudBackups: 'clearCloudBackups',
    }),
  },
};
</script>

<style scoped>
.cardTitle {
  display: flex;
  justify-content: space-between;
}

.errorText {
  color: var(--jc-color-error-base);
}

.notification {
  margin-bottom: var(--jc-spacer-medium);
}

.passwordManagerPrivateKeys {
  margin-bottom: var(--jc-spacer-medium);
}
</style>
